import { useState, useEffect, useCallback } from 'react';
import { createMachine } from '../createMachine';
import { useIsReady } from './useIsReady';
export function useCreateMachine(machineDefinition, options = {}) {
  const isReady = useIsReady(options);
  const [flushRender, setFlushRender] = useState(0);
  const [machine, setMachine] = useState(() => {
    return createMachine(machineDefinition, Object.assign({}, options, {
      waitToStart: true
    }));
  });
  function handleTransitionCallback(state) {
    setMachine(state);
    /**
     * @todo We should make this less hacky, but for now it works.
     * It looks like the useSyncExternalStore API is what makes the
     * most sense here.
     *
     * @see https://react.dev/reference/react/useSyncExternalStore
     */
    setFlushRender(prev => prev + 1);
  }
  useEffect(() => {
    const newMachine = createMachine(machineDefinition, Object.assign({}, options, {
      waitToStart: !isReady
    }));
    machine.mergeContext(options.initialContext);
    setMachine(newMachine);

    /**
     * We specifically only want to run this effect once, after the client initializes.
     */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (machine.isRunning() || !isReady) {
      return;
    }
    machine.mergeContext(options.initialContext);
    machine.onTransition(handleTransitionCallback);
    machine.start();

    /**
     * We only want to listen to isReady and don't care if the machine changes. If we
     * transition to a ready state and the machine isn't already running we need to
     * update it with the latest context and then start it.
     */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReady]);
  const send = useCallback(event => {
    machine.send(event);
  }, [machine]);
  return {
    state: machine,
    send,
    flushRender
  };
}